import React from 'react';

const BS_Home = () => {
    return (
        <div>
            <h1>BS_Home Component</h1>
            <p>Content coming soon...</p>
        </div>
    );
}

export default BS_Home;
